var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{ref:"header",class:("header " + _vm.align + " " + (_vm.padded ? 'padded' : '') + " " + (_vm.noWrap ? 'nowrap' : '') + " " + (_vm.stickied ? 'sticky' : ''))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }